var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCustomsStatusIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 18,
    viewBox: "0 0 19 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1901_16051)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.375 13.875L18.125 17.625M6.5 5.625V11.625M11 5.625V11.625M6.875 5.625C6.875 5.12772 7.07254 4.65081 7.42417 4.29917C7.77581 3.94754 8.25272 3.75 8.75 3.75C9.24728 3.75 9.72419 3.94754 10.0758 4.29917C10.4275 4.65081 10.625 5.12772 10.625 5.625M8.75 16.125C4.40075 16.125 0.875 12.5992 0.875 8.25C0.875 3.90075 4.40075 0.375 8.75 0.375C13.0992 0.375 16.625 3.90075 16.625 8.25C16.625 12.5992 13.0992 16.125 8.75 16.125ZM13.25 11.625H4.25V11.4375L4.346 10.86C4.59267 9.38021 4.59267 7.86979 4.346 6.39L4.25 5.8125V5.625H13.25V5.8125L13.154 6.39C12.9074 7.86979 12.9074 9.38021 13.154 10.86L13.25 11.4375V11.625Z",
    stroke: "white",
    strokeWidth: 1.5
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1901_16051"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white",
    transform: "translate(0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCustomsStatusIcon);
export default __webpack_public_path__ + "static/media/Customs Status Icon.f703e6dfad85b2b6fc716a34e170dd82.svg";
export { ForwardRef as ReactComponent };